<!-- @format -->

<div class="image-box">
	<picture *ngIf="!animation && image">
		<source
			*ngIf="mobileImage"
			[srcset]="mobileImage.value"
			media="(max-width: 766px)"
			[attr.alt]="
				altTagService(
					mobileImage.altText ? mobileImage.altText : altText ? altText : '',
					itemTitle
				)
			" />
		<ng-container *ngIf="willLazyLoad; then lazyLoad; else normalLoad"></ng-container>
	</picture>
	<video
		*ngIf="animation"
		muted
		playsinline
		controlsList="nofullscreen nodownload"
		onloadedmetadata="this.muted = true"
		oncanplay="play()"
		isVideo="true"
		[attr.alt]="
			altTagService(animation.altText ? animation.altText : altText ? altText : '', itemTitle)
		"
		[attr.poster]="image.value"
		[sharedUtilsDirectiveCommonLazyLoad]="animation.value">
		Your browser does not support the video tag.
	</video>
</div>

<ng-template #normalLoad>
	<source
		type="image/webp"
		[srcset]="image.value" />
	<img
		[src]="image.value"
		class="hmf-soft-radius"
		[attr.alt]="
			altTagService(image.altText ? image.altText : altText ? altText : '', itemTitle)
		"
		[attr.fetchpriority]="prioritize ? 'high' : 'auto'" />
</ng-template>
<ng-template #lazyLoad>
	<img
		[sharedUtilsDirectiveCommonLazyLoad]="image.value"
		[attr.alt]="
			altTagService(image.altText ? image.altText : altText ? altText : '', itemTitle)
		"
		class="hmf-soft-radius"
		loading="lazy" />
</ng-template>
